import HeaderImage from "./HeaderImage";
import { Container, StyledParagraph } from "../styled";

export default () => (
    <Container>
        <HeaderImage/>
        <StyledParagraph>
            <strong>kósmos </strong><em>&ndash;&nbsp;(etym. gr. </em>κόσμος<em>) porządek, ład, ozdoba,</em> <em>przestrzeń, czas, materia i energia</em>
        </StyledParagraph>
        <StyledParagraph>
            <strong>kosmos </strong><em>–&nbsp;wszystko co fizycznie istnieje – przestrzeń, czas, materia i energia</em><br />Tworzymy kompleksowe projekty  architektury i urbanistyki o różnorodnej skali i poziomie skomplikowania.
        </StyledParagraph>
        <StyledParagraph>
            <strong>kosmos </strong><em>– porządek, ład, ozdoba, przeciwieństwo chaosu</em><br />Zapewniamy wsparcie na każdym etapie inwestycji – od koncepcji, poprzez uzyskanie pozwolenia na budowę, po nadzór w realizacji.
        </StyledParagraph>
        <StyledParagraph>
            <strong>studio kosmos</strong> – <em>nasza przestrzeń, nasz czas i energia włożone</em> <em>w tworzenie ładu – projektów trwałych, użytecznych i pięknych</em>
        </StyledParagraph>
    </Container>
);